import { Injectable } from '@angular/core';
import { BaseModelService } from '../base-model.service';

@Injectable({
  providedIn: 'root',
})
export class NoticeFamiliesModelService extends BaseModelService {
  tableName = 'yu_v3_notice_families';
}
